var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 92,
    viewBox: "0 0 65 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1400_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8867 18.0344L58.9856 84.3865L32.4601 91.7675L6.00761 84.3969L0.112793 18.0344H64.8867Z",
    fill: "#E44D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 86.1258L53.9339 80.1614L58.9768 23.4606H32.5V86.1258Z",
    fill: "#F16529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0282 39.7389H32.4996V31.5997H12.166L12.3601 33.7833L14.3532 56.2124H32.4996V48.0734H21.7692L21.0282 39.7389Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.856 60.2821H14.7158L15.8519 73.0616L32.4626 77.69L32.4999 77.6796V69.2115L32.4644 69.221L23.4333 66.7734L22.856 60.2821Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13916 0H10.2601V4.08652H14.0297V0H18.1508V12.375H14.0299V8.23112H10.2602V12.375H6.13934V0H6.13916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5702 4.10373H19.9424V0H31.321V4.10373H27.6915V12.375H23.5704V4.10373H23.5702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.127 0H37.4239L40.0671 4.3482L42.7077 0H47.0062V12.375H42.9023V6.24127L40.0671 10.6413H39.9962L37.1591 6.24127V12.375H33.127V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0571 0H53.1793V8.28453H58.9745V12.375H49.0571V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4717 56.2125H42.457L41.5158 66.7683L32.4717 69.2184V77.6861L49.0956 73.0617L49.2176 71.6866L51.1231 50.2591L51.321 48.0735H32.4717V56.2125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4717 39.719V39.7389H52.0588L52.2215 37.9095L52.591 33.7833L52.7849 31.5997H32.4717V39.719Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1400_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 92,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.c330da3f6855b3109b9f0848aedbad74.svg";
export { ForwardRef as ReactComponent };